import axios, { AxiosInstance } from 'axios';

function createAxiosInstance(baseURL?: string | null): AxiosInstance {
  const api: AxiosInstance = axios.create({
    baseURL: baseURL || process.env.VUE_APP_API_URL || process.env.mainApiBaseUrl,
    headers: {
      common: {
        Accept: 'application/json'
      }
    },
  });

  api.interceptors.response.use(
    response => response.data,
    error => error,
  );

  return api;
}

export default createAxiosInstance;
